import { Box, Container, Flex, Heading, Text, useColorModeValue } from "@chakra-ui/react";
import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

const AuthLayout = ({ children, title, subtitle }: AuthLayoutProps) => {
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const cardBgColor = useColorModeValue("white", "gray.800");

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg={bgColor}
      py={12}
      px={4}
    >
      <Container maxW="lg">
        <Box
          bg={cardBgColor}
          rounded="lg"
          boxShadow="lg"
          p={8}
          mb={6}
          textAlign="center"
        >
          <Heading fontSize="2xl" fontWeight="bold" mb={2}>
            {title}
          </Heading>
          {subtitle && (
            <Text fontSize="md" color="gray.600" mb={6}>
              {subtitle}
            </Text>
          )}
          {children}
        </Box>
        <Text textAlign="center" fontSize="sm" color="gray.500">
          Legal Billable Hours Tracker &copy; {new Date().getFullYear()}
        </Text>
      </Container>
    </Flex>
  );
};

export default AuthLayout;